import { get } from 'lodash';

export default function somePerformed(tabData, options) {
  return options.paths.some((path) => {
    const value = get(tabData, path);
    return value !== '' && value != null;
  });
}
